import { useOpenContractMutation } from '@/api/queries/contract';
import { playSound } from '@/common/lib/soundEffect';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { selectSpecContractIdByKind } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

interface UseOpenSpecContractReturnType {
  onClick: () => void;
  isLoading: boolean;
  disabled: boolean;
}

const useOpenSpecContract = (
  kind: SpecContractType | PaidSpecContractType,
): UseOpenSpecContractReturnType => {
  const contractId = useAppSelector((state) =>
    selectSpecContractIdByKind(state, kind),
  );
  const [openSpecContract, { isLoading }] = useOpenContractMutation();

  const onClick = (): void => {
    playSound('contracts/open');

    if (!contractId) {
      return;
    }
    openSpecContract({ contractId, type: kind });
  };

  return {
    onClick,
    isLoading,
    disabled: isLoading,
  };
};

export { useOpenSpecContract };
